import * as React from 'react';
import { observer } from 'mobx-react';

import { CheckboxTracked } from 'components/shared/tracked';
import { FlightsListDisplayFilterItemType } from 'types/shared';
import { FILTER_TYPE_TO_VALUE } from 'utility/filter-constants';
import { useStores } from 'utility/hooks';
import { liveAnnounce } from 'uitk-react-utils';
import { trackAnalytics } from 'utility';

interface ListFilterProps {
  filterItem: FlightsListDisplayFilterItemType;
  idPrefix: string;
  keySuffix: string;
  updateFilter: (keySuffix: string) => void;
}

export const ListFilter = observer((props: ListFilterProps) => {
  const { sortFilterStore, analytics } = useStores();
  const { filterItem, idPrefix, keySuffix } = props;
  const {
    accessibility,
    deselectAnalytics,
    value,
    label,
    selectAnalytics,
    selected,
    startingPrice,
    selectPositionAnalytics
  } = filterItem;
  const filterValue = FILTER_TYPE_TO_VALUE[value.__typename](value);
  const labelId = `${idPrefix}-${filterValue}-label`;
  const elementId = `${idPrefix}-${filterValue}`;
  const filterAnalytics = selected ? deselectAnalytics : selectAnalytics;

  const handleOnChange = () => {
    const { updateFilter } = props;
    const {
      filterPresentation: { accessibility }
    } = sortFilterStore;

    filterItem.selected = !filterItem.selected;

    if (filterItem.selected) {
      sortFilterStore.increaseAppliedFilterCount();
      trackAnalytics(selectPositionAnalytics, analytics);
    } else {
      sortFilterStore.decreaseAppliedFilterCount();
    }

    updateFilter(keySuffix);
    liveAnnounce(accessibility.onCompletion);
  };

  return (
    <div className="uitk-flex uitk-flex-justify-content-space-between" key={`filter-item-${label}-${keySuffix}`}>
      <CheckboxTracked
        id={elementId}
        data-test-id={elementId}
        checked={selected}
        name={idPrefix}
        value={filterValue}
        onChange={handleOnChange}
        {...filterAnalytics}
      >
        <span data-test-id={labelId} aria-hidden="true">
          {label}
        </span>
        {accessibility && accessibility.usage && (
          <span id={labelId} className="is-visually-hidden">
            {accessibility.usage}
          </span>
        )}
      </CheckboxTracked>
      {startingPrice && (
        <div className="uitk-type-300 all-t-padding-two" aria-hidden="true">
          {startingPrice.formatted}
        </div>
      )}
    </div>
  );
});
